export default __webpack_public_path__ + "static/media/020-bicycle.1e503aba.png";